//
import axios from 'axios'
import FamilyBurdenModel from "@/models/HumanResource/HrFamilyBurden"

/**
 * 
 */
const create = async data => {

    //
    try {

        //
        const response = await ( new FamilyBurdenModel( data ) ).save()
        
        //
        return response
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const remove = async id => {

    //
    try {

        //
        const response = await axios.delete( process.env.VUE_APP_API_ROUTE + '/hr_family_burden/' + id )

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default {
    create,
    remove,
}
